import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./FAQPop.module.scss";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import {
  useAddFAQMutation,
  useUpdateFAQMutation,
} from "../../../store/services/FAQServices";
import toast from "react-hot-toast";
import CKEditorNew from "../../newCkEditor/ckEditor";
//import CKEditorField from "../../ckEditor/CKEditorField";

// make faq type dropdown 'GETTING_STARTED', 'MEAL_PLANS', 'DELIVERY', 'AFTER_RECEIVING_YOUR_ORDER', 'CHANGES_TO_YOUR_MEAL_PLAN', 'PAYMENT', 'CONTACTING_US']
const options = [
  { value: "Getting Started", label: "Getting Started" },
  { value: "Meal Plans", label: "Meal Plans" },
  { value: "Delivery", label: "Delivery" },
  { value: "After Receiving Your Order", label: "After Receiving Your Order" },
  { value: "Changes To Your Meal Plan", label: "Changes To Your Meal Plan" },
  { value: "Payment", label: "Payment" },
  { value: "Contacting Us", label: "Contacting Us" },
];

const FAQPop = ({ title, modalOpen, setModalOpen, edit }) => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      question: edit?.question,
      status: edit?.status,
      answer: edit?.answer,
      type: edit?.type,
    },
  });

  const [addFAQ, { isLoading: isAdding }] = useAddFAQMutation();
  const [updateFAQ, { isLoading: isUpdating }] = useUpdateFAQMutation();

  // Submit handler
  const onSubmit = async (data) => {
    try {
      let res = "";
      if (edit !== null) {
        // Update existing meal
        res = await updateFAQ({
          ingredientId: edit._id,
          updatedData: data,
        });
      } else {
        res = await addFAQ(data).unwrap(); // Call deleteFAQ and handle success
      }

      setModalOpen(false);
      // return toast.success(res?.data?.message);
      return toast.success(`FAQ ${edit ? "updated" : "added"} successfully`);
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      show={modalOpen}
      className={`${styles.FAQPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
      size="lg"
      enforceFocus={false}
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg="12" md="12" className="my-2">
                  {/* Name Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Question
                    </label>
                    <input
                      type="text"
                      placeholder="Enter question"
                      name="question"
                      // {...register("question", {
                      //   required: "Please enter question",
                      // })}
                      {...register("question", {
                        required: "Please enter question",
                        validate: (value) => {
                          if (/^\s/.test(value)) {
                            return "Question cannot start with a space";
                          }
                          // if (/[^a-zA-Z0-9\s]/.test(value)) {
                          //   return "Question cannot include special characters or emojis";
                          // }
                          return true;
                        },
                      })}
                      className="form-control"
                    />

                    {errors.question && (
                      <span className="text-danger">
                        {errors.question.message}
                      </span>
                    )}
                  </div>
                </Col>

                {/* <Col lg="12" md="12" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Answer
                    </label>

                    <Controller
                      name="answer"
                      control={control}
                      rules={{ required: "Please enter answer" }}
                      render={({ field }) => (
                        <CKEditorField
                          field="answer"
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors}
                        />
                      )}
                    />
                   
                    {errors.content && (
                      <span className="text-danger">
                        {errors.content.message}
                      </span>
                    )}
                  </div>
                </Col> */}

                <Col lg="12" md="12" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Answer
                    </label>

                    <Controller
                      name="answer"
                      control={control}
                      rules={{ required: "Please enter answer" }}
                      render={({ field }) => (
                        <CKEditorNew
                          field="answer"
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors}
                        />
                      )}
                    />

                    {errors.content && (
                      <span className="text-danger">
                        {errors.content.message}
                      </span>
                    )}
                  </div>
                </Col>

                <Col lg="12" md="12" className="my-2">
                  {/* type Field select */}
                  <div className="py-2">
                    <label
                      htmlFor="type"
                      className="form-label fw-sbold text-muted ps-2 m-0"
                    >
                      Select Type:
                    </label>
                    <Controller
                      name="type"
                      control={control}
                      rules={{ required: "Type is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={options}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select Type"
                          value={options.find(
                            (option) => option.value === field.value
                          )} // Show selected value
                          // Set only the `value` to the form field
                          onChange={(selectedOption) =>
                            field.onChange(selectedOption.value)
                          }
                        />
                      )}
                    />
                    {errors.type && (
                      <span className="text-danger">{errors.type.message}</span>
                    )}
                  </div>
                </Col>
                <Col lg="6" md="6" className="my-2">
                  {/* Status Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Status
                    </label>
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="active"
                          {...register("status", {
                            required: "One Radio button should appear selected",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Active
                        </label>
                      </li>
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="inactive"
                          {...register("status", {
                            required: "One Radio button should appear selected",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Inactive
                        </label>
                      </li>
                    </ul>
                    {errors.status && (
                      <span className="text-danger">
                        {errors.status.message}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>

          {/* <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100"
              >
                {title}
              </Button>
            </div>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FAQPop;
